import type { ApiModuleEndpoints } from '../types'

export const staffApiEndpoints = {
  list: {
    method: 'GET',
    path: '/staffs',
    requiresAuth: true,
  },
  detail: {
    method: 'GET',
    path: '/staffs/:id',
    requiresAuth: true,
  },
  create: {
    method: 'POST',
    path: '/staffs',
    requiresAuth: true,
  },
  importTemplate: {
    method: 'GET',
    path: '/staffs/import-template',
    requiresAuth: true,
  },
  update: {
    method: 'PUT',
    path: '/staffs/:id',
    requiresAuth: true,
  },
  delete: {
    method: 'DELETE',
    path: '/staffs/:id',
    requiresAuth: true,
  },
  restore: {
    method: 'POST',
    path: '/staffs/:id/restore',
    requiresAuth: true,
  },
  resetPassword: {
    method: 'POST',
    path: '/staffs/:id/reset-password',
    requiresAuth: true,
  },
  avatarPresign: {
    method: 'POST',
    path: '/staffs/:id/avatar/presign',
    requiresAuth: true,
  },
  avatarConfirm: {
    method: 'POST',
    path: '/staffs/:id/avatar/confirm',
    requiresAuth: true,
  },
  avatarDelete: {
    method: 'DELETE',
    path: '/staffs/:id/avatar',
    requiresAuth: true,
  },
  faceProfile: {
    method: 'GET',
    path: '/staffs/:id/face',
    requiresAuth: true,
  },
  facePresign: {
    method: 'POST',
    path: '/staffs/:id/face/presign',
    requiresAuth: true,
  },
  faceConfirm: {
    method: 'POST',
    path: '/staffs/:id/face/confirm',
    requiresAuth: true,
  },
  faceDelete: {
    method: 'DELETE',
    path: '/staffs/:id/face',
    requiresAuth: true,
  },
  departments: { method: 'GET', path: '/staff/departments', requiresAuth: true },
  departmentDetail: { method: 'GET', path: '/staff/departments/:id', requiresAuth: true },
  createDepartment: { method: 'POST', path: '/staff/departments', requiresAuth: true },
  updateDepartment: { method: 'PUT', path: '/staff/departments/:id', requiresAuth: true },
  deleteDepartment: { method: 'DELETE', path: '/staff/departments/:id', requiresAuth: true },
  departmentStaffOptions: {
    method: 'GET',
    path: '/staff/departments/:id/staff-options',
    requiresAuth: true,
  },
  workShifts: { method: 'GET', path: '/staff/work-shifts', requiresAuth: true },
  createWorkShift: { method: 'POST', path: '/staff/work-shifts', requiresAuth: true },
  updateWorkShift: { method: 'PUT', path: '/staff/work-shifts/:id', requiresAuth: true },
  deleteWorkShift: { method: 'DELETE', path: '/staff/work-shifts/:id', requiresAuth: true },
  assignments: { method: 'GET', path: '/staff/shift-assignments', requiresAuth: true },
  createAssignment: { method: 'POST', path: '/staff/shift-assignments', requiresAuth: true },
  bulkAssignments: { method: 'POST', path: '/staff/shift-assignments/bulk', requiresAuth: true },
  assignmentBatches: {
    method: 'GET',
    path: '/staff/shift-assignments/batches',
    requiresAuth: true,
  },
  assignmentBatchDetail: {
    method: 'GET',
    path: '/staff/shift-assignments/batches/:id',
    requiresAuth: true,
  },
  deleteAssignmentBatch: {
    method: 'DELETE',
    path: '/staff/shift-assignments/batches/:id',
    requiresAuth: true,
  },
  updateAssignmentBatch: {
    method: 'PUT',
    path: '/staff/shift-assignments/batches/:id',
    requiresAuth: true,
  },
  updateAssignment: { method: 'PUT', path: '/staff/shift-assignments/:id', requiresAuth: true },
  deleteAssignment: { method: 'DELETE', path: '/staff/shift-assignments/:id', requiresAuth: true },
  attendanceToday: { method: 'GET', path: '/staff/attendances/today', requiresAuth: true },
  attendancePunch: { method: 'POST', path: '/staff/attendances/punch', requiresAuth: true },
  attendanceOnlinePunch: { method: 'POST', path: '/staff/attendances/online-punch', requiresAuth: true },
  attendanceHistory: { method: 'GET', path: '/staff/attendances/history', requiresAuth: true },
  attendanceDashboard: { method: 'GET', path: '/staff/attendances/dashboard', requiresAuth: true },
  attendanceMonthlyHistory: {
    method: 'GET',
    path: '/staff/attendances/monthly-history',
    requiresAuth: true,
  },
  attendanceUnpaidLeave: { method: 'POST', path: '/staff/attendances/unpaid-leave', requiresAuth: true },
  attendanceTotalTime: { method: 'GET', path: '/staff/attendances/total-time', requiresAuth: true },
  attendanceStaffOptions: {
    method: 'GET',
    path: '/staff/attendances/staff-options',
    requiresAuth: true,
  },
  attendanceSettings: { method: 'GET', path: '/staff/attendances/settings', requiresAuth: true },
  updateAttendanceSettings: {
    method: 'PUT',
    path: '/staff/attendances/settings',
    requiresAuth: true,
  },
  attendanceAdjustmentCount: {
    method: 'GET',
    path: '/staff/attendances/adjustment-requests/count',
    requiresAuth: true,
  },
  myAttendanceAdjustmentRequests: {
    method: 'GET',
    path: '/staff/attendances/adjustment-requests/mine',
    requiresAuth: true,
  },
  attendanceAdjustmentRequests: {
    method: 'GET',
    path: '/staff/attendances/adjustment-requests',
    requiresAuth: true,
  },
  createAttendanceAdjustment: {
    method: 'POST',
    path: '/staff/attendances/adjustment-requests',
    requiresAuth: true,
  },
  cancelAttendanceAdjustment: {
    method: 'DELETE',
    path: '/staff/attendances/adjustment-requests/:id',
    requiresAuth: true,
  },
  approveAttendanceAdjustment: {
    method: 'POST',
    path: '/staff/attendances/adjustment-requests/:id/approve',
    requiresAuth: true,
  },
  rejectAttendanceAdjustment: {
    method: 'POST',
    path: '/staff/attendances/adjustment-requests/:id/reject',
    requiresAuth: true,
  },
  profileShow: {
    method: 'GET',
    path: '/staffs/:id/profile',
    requiresAuth: true,
  },
  profileUpdatePersonal: {
    method: 'PUT',
    path: '/staffs/:id/profile/personal',
    requiresAuth: true,
  },
  profileIdentityDocuments: {
    method: 'GET',
    path: '/staffs/:id/profile/identity-documents',
    requiresAuth: true,
  },
  profileCreateIdentityDocument: {
    method: 'POST',
    path: '/staffs/:id/profile/identity-documents',
    requiresAuth: true,
  },
  profileUpdateIdentityDocument: {
    method: 'PUT',
    path: '/staffs/:id/profile/identity-documents/:recordId',
    requiresAuth: true,
  },
  profileDeleteIdentityDocument: {
    method: 'DELETE',
    path: '/staffs/:id/profile/identity-documents/:recordId',
    requiresAuth: true,
  },
  profileVerifyIdentityDocument: {
    method: 'POST',
    path: '/staffs/:id/profile/identity-documents/:recordId/verify',
    requiresAuth: true,
  },
  profilePresignIdentityDocumentFile: {
    method: 'POST',
    path: '/staffs/:id/profile/identity-documents/file/presign',
    requiresAuth: true,
  },
  profileConfirmIdentityDocumentFile: {
    method: 'POST',
    path: '/staffs/:id/profile/identity-documents/file/confirm',
    requiresAuth: true,
  },
  profileDiscardIdentityDocumentFile: {
    method: 'DELETE',
    path: '/staffs/:id/profile/identity-documents/file',
    requiresAuth: true,
  },
  profileAddresses: {
    method: 'GET',
    path: '/staffs/:id/profile/addresses',
    requiresAuth: true,
  },
  profileCreateAddress: {
    method: 'POST',
    path: '/staffs/:id/profile/addresses',
    requiresAuth: true,
  },
  profileUpdateAddress: {
    method: 'PUT',
    path: '/staffs/:id/profile/addresses/:recordId',
    requiresAuth: true,
  },
  profileDeleteAddress: {
    method: 'DELETE',
    path: '/staffs/:id/profile/addresses/:recordId',
    requiresAuth: true,
  },
  profileEmergencyContacts: {
    method: 'GET',
    path: '/staffs/:id/profile/emergency-contacts',
    requiresAuth: true,
  },
  profileCreateEmergencyContact: {
    method: 'POST',
    path: '/staffs/:id/profile/emergency-contacts',
    requiresAuth: true,
  },
  profileUpdateEmergencyContact: {
    method: 'PUT',
    path: '/staffs/:id/profile/emergency-contacts/:recordId',
    requiresAuth: true,
  },
  profileDeleteEmergencyContact: {
    method: 'DELETE',
    path: '/staffs/:id/profile/emergency-contacts/:recordId',
    requiresAuth: true,
  },
  profileFamilyMembers: {
    method: 'GET',
    path: '/staffs/:id/profile/family-members',
    requiresAuth: true,
  },
  profileCreateFamilyMember: {
    method: 'POST',
    path: '/staffs/:id/profile/family-members',
    requiresAuth: true,
  },
  profileUpdateFamilyMember: {
    method: 'PUT',
    path: '/staffs/:id/profile/family-members/:recordId',
    requiresAuth: true,
  },
  profileDeleteFamilyMember: {
    method: 'DELETE',
    path: '/staffs/:id/profile/family-members/:recordId',
    requiresAuth: true,
  },
  profileBankAccounts: {
    method: 'GET',
    path: '/staffs/:id/profile/bank-accounts',
    requiresAuth: true,
  },
  profileCreateBankAccount: {
    method: 'POST',
    path: '/staffs/:id/profile/bank-accounts',
    requiresAuth: true,
  },
  profileUpdateBankAccount: {
    method: 'PUT',
    path: '/staffs/:id/profile/bank-accounts/:recordId',
    requiresAuth: true,
  },
  profileDeleteBankAccount: {
    method: 'DELETE',
    path: '/staffs/:id/profile/bank-accounts/:recordId',
    requiresAuth: true,
  },
  profileVerifyBankAccount: {
    method: 'POST',
    path: '/staffs/:id/profile/bank-accounts/:recordId/verify',
    requiresAuth: true,
  },
  profileTaxInsurance: {
    method: 'GET',
    path: '/staffs/:id/profile/tax-insurance',
    requiresAuth: true,
  },
  profileUpdateTaxProfile: {
    method: 'PUT',
    path: '/staffs/:id/profile/tax-profile',
    requiresAuth: true,
  },
  profileUpdateSocialInsuranceProfile: {
    method: 'PUT',
    path: '/staffs/:id/profile/social-insurance-profile',
    requiresAuth: true,
  },
  profileDocuments: {
    method: 'GET',
    path: '/staffs/:id/profile/documents',
    requiresAuth: true,
  },
  profileCreateDocument: {
    method: 'POST',
    path: '/staffs/:id/profile/documents',
    requiresAuth: true,
  },
  profileUpdateDocument: {
    method: 'PUT',
    path: '/staffs/:id/profile/documents/:recordId',
    requiresAuth: true,
  },
  profileDeleteDocument: {
    method: 'DELETE',
    path: '/staffs/:id/profile/documents/:recordId',
    requiresAuth: true,
  },
  profileVerifyDocument: {
    method: 'POST',
    path: '/staffs/:id/profile/documents/:recordId/verify',
    requiresAuth: true,
  },
  profilePresignDocumentFile: {
    method: 'POST',
    path: '/staffs/:id/profile/documents/file/presign',
    requiresAuth: true,
  },
  profileConfirmDocumentFile: {
    method: 'POST',
    path: '/staffs/:id/profile/documents/file/confirm',
    requiresAuth: true,
  },
  profileDiscardDocumentFile: {
    method: 'DELETE',
    path: '/staffs/:id/profile/documents/file',
    requiresAuth: true,
  },
  profileConsents: {
    method: 'GET',
    path: '/staffs/:id/profile/consents',
    requiresAuth: true,
  },
  profileCreateConsent: {
    method: 'POST',
    path: '/staffs/:id/profile/consents',
    requiresAuth: true,
  },
  profileUpdateConsent: {
    method: 'PUT',
    path: '/staffs/:id/profile/consents/:recordId',
    requiresAuth: true,
  },
  profileDeleteConsent: {
    method: 'DELETE',
    path: '/staffs/:id/profile/consents/:recordId',
    requiresAuth: true,
  },
  overrideAttendanceCheckIn: {
    method: 'POST',
    path: '/staff/attendances/:id/override-check-in',
    requiresAuth: true,
  },
  overrideAttendanceAssignment: {
    method: 'POST',
    path: '/staff/attendances/assignments/:id/override',
    requiresAuth: true,
  },
  attendanceDevice: { method: 'GET', path: '/attendance-devices', requiresAuth: true },
  provisionAttendanceDevice: {
    method: 'POST',
    path: '/attendance-devices/provision',
    requiresAuth: true,
  },
  disableAttendanceDevice: {
    method: 'POST',
    path: '/attendance-devices/:device/disable',
    requiresAuth: true,
  },
  releaseAttendanceDevice: {
    method: 'DELETE',
    path: '/attendance-devices/:device',
    requiresAuth: true,
  },
} as const satisfies ApiModuleEndpoints
